import { Component, OnInit, Input, Optional } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import { Encrypt } from '../../../utils/encrypt/encrypt';
import { CookieCiencuadras } from '../../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { addToCar, modifyProduct, removeToCar } from '../../../redux/actions/carCheckout.actions';
import { Plan } from '../../../models/plan.model';
import { ProductCar } from '../../../models/productCar.model';
import { Product } from '../../../models/product.model';
import { UserInformation } from '../../../models/userInformation.model';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DetailModalComponent } from '../detail-modal/detail-modal.component';
import { DataLayerService } from 'src/app/services/dataLayer/data-layer.service';
import { ProductsService } from '../../../services/products/products.service';
import { environment } from '@env/environment';
import { ConfirmTelephoneComponent } from '../confirm-telephone/confirm-telephone.component';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {

  @Input()
  productData!: Product;
  @Input()
  dataIndex!: number;
  count: number = 0;
  countPlan: number = 0;
  summaryP: number = 0;
  summaryPlan: number = 0;
  plansSelected: Plan[] = [];
  aditionalProducts: ProductCar[] = [];
  userInformation: UserInformation;
  userPrivateZone: boolean = false;
  havePlan: boolean = false;
  isUpdateUserInformationRequiered = false;
  isSaveTransactionFail = false;
  image_url: string = './assets/images/products/';
  user_id: string = '';


  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<ConfirmTelephoneComponent>,
    private dataLayerService: DataLayerService,
    private productsService: ProductsService,
    private cookieCiencuadras: CookieCiencuadras
    ) { }

  ngOnInit(): void {
    if (document.location.pathname === '/productos/zona-de-usuario') {
      this.userPrivateZone = true;
    }

    let cripto = new Encrypt();

    this.user_id = this.cookieCiencuadras.getCookie('user_id') ? this.cookieCiencuadras.getCookie('user_id') : localStorage.getItem('currentUser');

    this.store.select('carPlanCheckout').subscribe(plan => {
      this.countPlan = 0;
      plan.forEach(item => {
        this.plansSelected.push(item);
        this.countPlan = plan.length;
        this.summaryPlan = item.priceDiscount;
        this.summaryP = this.summaryP + this.summaryPlan;
      });
    });

    this.store.select('carCheckout').subscribe( product =>{
      this.aditionalProducts = product;
      let found = product.find(prueba => prueba.id === this.productData.id);
      found ? this.count = found.quantity: this.count = 0;
    });

    let dataUser = this.cookieCiencuadras.getCookie('userInfo');
    this.userInformation = cripto.decryptData(dataUser);
  }

  async add(){

    let counter = this.count + 1;
    let nameEvent = this.productData.prodCategory == 3? "addToCart" : "addToCart";
    this.dataLayerService.pushTagByEventCar(this.productData, nameEvent, 'add', 1, true);

    let product = {
      external_product_id : Date.now().toString(),
      carritoId : this.productData.carritoId,
      token : "",
      id : this.productData.id,
      name : this.productData.name,
      summary : this.productData.summary,
      price : this.productData.price,
      basePrice: this.productData.basePrice,
      quantityPlan: this.productData.quantityPlan,
      prodCategory: this.productData.prodCategory,
      code: this.productData.code,
      createdManual: this.productData.createdManual,
      stock : this.productData.stock ,
      available_stock : this.productData.available_stock,
      image_url : this.productData.image_url,
      image_alt : this.productData.image_alt,
      iva : this.productData.iva,
      priceIva: this.productData.priceIva,
      originId: this.productData.originId,
      idClientType : this.productData.idClientType,
      discount: this.productData.discount,
      priceDiscount: this.productData.priceDiscount,
      detailModal: this.productData.detailModal,
      quantity: counter,
      totalPrice: this.productData.priceDiscount
    }
    if (counter === 1) {
      this.store.dispatch(addToCar({product}));
      await this.consultingInformation();
    }else{
      this.store.dispatch(modifyProduct({id: product.id, count: product.quantity}));
      await this.consultingInformation();
    }

   /* this.dataLayerService.onPushDataLayer({
      '​event': 'addToCart',
      '​ecommerce': {
        'currencyCode': '​COP',
        'add': {
          '​products': [{
            'name': this.productData.name,
            'id': this.productData.id,
            'price': this.productData.priceDiscount,
            'category': 'Publicacion',
            'quantity': counter
          }]
        }
      }
    });*/

  }

  async remove(){
    if(this.count !== 0){
      let counter = this.count - 1;
      let nameEvent = this.productData.prodCategory == 3? "removeFromCart" : "removeFromCart";
      this.dataLayerService.pushTagByEventCar(this.productData, nameEvent, 'remove', 1, true);
      let product = {
        id : this.productData.id,
        name : this.productData.name,
        summary : this.productData.summary,
        price : this.productData.price,
        basePrice: this.productData.basePrice,
        quantityPlan: this.productData.quantityPlan,
        prodCategory: this.productData.prodCategory,
        code: this.productData.code,
        createdManual: this.productData.createdManual,
        stock : this.productData.stock ,
        available_stock : this.productData.available_stock,
        image_url : this.productData.image_url,
        image_alt : this.productData.image_alt,
        iva : this.productData.iva,
        priceIva: this.productData.priceIva,
        originId: this.productData.originId,
        idClientType : this.productData.idClientType,
        discount: this.productData.discount,
        priceDiscount: this.productData.priceDiscount,
        detailModal: this.productData.detailModal,
        quantity: counter,
        totalPrice: this.productData.priceDiscount
      }
      if(this.count === 1){
        this.store.dispatch(removeToCar({id: product.id}));
        await this.consultingInformation();
      }else{
        this.store.dispatch(modifyProduct({id: product.id, count: product.quantity}));
        await this.consultingInformation();
      }

      /*this.dataLayerService.onPushDataLayer({
        '​event': 'removeFromCart',
        '​ecommerce': {
          'remove': {
            'products': [{
              'name': this.productData.name,
              '​id': this.productData.id,
              'price': this.productData.price,
              '​brand': 'Google',
              '​category': 'Publicacion',
              '​variant': '​Gray',
              '​quantity': counter,
            }],
          }
        }
      });*/
    }
  }

  openDetailDialog (){
    const detailConfig = new MatDialogConfig();
    detailConfig.panelClass = 'detail-modal';
    detailConfig.maxWidth = '100vw';
    detailConfig.data = this.productData;
    this.dialog.open(DetailModalComponent, detailConfig);
  }
  
  async consultingInformation() {
  
    let dataLayerProduct: { name: string; id: number; price: number; category: string; quantity: number; }[] = [];

    if (this.plansSelected.length > 0) {
      this.plansSelected.forEach(plan => {
        const newPlan = {
          name: plan.name,
          id: plan.id,
          price: plan.priceDiscount,
          category: "Publicacion",
          quantity: 1,
        }
        dataLayerProduct.push(newPlan)
      });
    }
  
    if (this.aditionalProducts.length > 0) {
      this.aditionalProducts.forEach(product => {
        const newProduct = {
          name: product.name,
          id: product.id,
          price: product.priceDiscount,
          category: "Publicacion",
          quantity: product.quantity,
        }
        dataLayerProduct.push(newProduct)
      });
    }
  
    this.dataLayerService.onPushDataLayer({
      event: "checkout",
      ecommerce: {
        checkout: {
          actionField: { step: 1, option: "Medio de pago seleccionado" },
          products: dataLayerProduct,
        },
      },
    });
  
    if (this.user_id) {
      let userInformation: boolean = await this.getUserInformation(this.user_id);
      this.beforeBuy(userInformation);
    }
  }

  async beforeBuy(userInformation: boolean) {

    if (userInformation) {
      let typeUser = this.userInformation.typeUser;
      let openDialog: boolean;

      if (typeUser === 9) {
        if (!this.userInformation.phone || !this.userInformation.cellPhone) {
          openDialog = await this.phoneValidation();
        } else {
          openDialog = true;
        }

      } else {
        openDialog = true;
      }

      if (openDialog) {
        await this.getUserInformation(this.user_id);
        if (this.havePlan === false || this.userPrivateZone) {
          await this.buy();
        }
      } else {
        if (typeUser === 9) {
          this.isUpdateUserInformationRequiered = true;
        }
      }
    }
  }

  async buy(fromView = false) {
    if(fromView) {
      this.dataLayerService.pushTagEventClick({'event':'ga_event','category':'productos','action':'CCW - planes activos','label':'si'});
    }
    this.isSaveTransactionFail = false;
    if (this.plansSelected.length >= 1 && this.havePlan === false) {
      await this.addBulkProducts();
      await this.saveTransactionService();

    } else if (this.havePlan || this.userInformation.typeUser === 9) {
      await this.addBulkProducts();
      await this.saveTransactionService();

    } else if (this.userPrivateZone) {
      await this.addBulkProducts();
      await this.saveTransactionService();

    } else {
      this.dialog.closeAll();
    }

  }

  async phoneValidation() {
    this.dialogRef = this.dialog.open(ConfirmTelephoneComponent, {
      width: "500px",
      panelClass: "full-mobile",
    });

    return this.dialogRef?.afterClosed()
      .toPromise() // here you have a Promise instead an Observable
      .then(result => {
        return Promise.resolve(result); // will retun a Promise here
      });
  }

  async addBulkProducts() {
    if(this.plansSelected.length > 1){
      this.plansSelected.shift();
    }
    const userID = (this.userInformation.identification) ? this.userInformation.identification : this.userInformation.id.toString()
    let allProducts: any = [];
    if (this.plansSelected.length > 0) {
      let planSelectedData = this.addDataProducts(this.plansSelected[0], 1, false);
      planSelectedData.marketo_custom_object.nombreProducto = "";
      planSelectedData.marketo_custom_object.valorProducto = "";
      planSelectedData.marketo_custom_object.cuposProducto = "";
      planSelectedData.marketo_custom_object.fechaInicioProducto = "";
      planSelectedData.marketo_custom_object.fechaFinProducto = "";
      allProducts.push(planSelectedData);
    }
    if (this.aditionalProducts.length > 0) {
      for (let i = 0; i < this.aditionalProducts.length; i++) {
        let productData = this.addDataProducts(this.aditionalProducts[i], 2, true);
        allProducts.push(productData);
      }
    }
    let jsonData = {
      "external_user_id": userID,
      "external_user_name": this.userInformation.name,
      "external_user_email": this.userInformation.email,
      "external_user_phone": (this.userInformation.phone && this.userInformation.phone !== null) ? this.userInformation.phone.toString() : '7492313412',
      "products": allProducts
    }

    await this.productsService.addBulkProducts(jsonData).then(res => {
      let data = res.result;
      if (res.status === "ok") {
        localStorage.setItem("tokenProduct", data.token.toString());
        this.cookieCiencuadras.setCookie('tokenProduct', data.token.toString());
      }
    }).catch((err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log('An error occurred:', err.error.message);
      }
      else {
        console.log('Backend returned status code: ', err.status);
        console.log('Response body:', err.error);
      }
    });
    return Promise.resolve(true);
  }

  addDataProducts(product: any, tipoItem: number, aditional: boolean) {
    const dataLayer = [
      {
        "name": "brand",
        "value": "ciencuadras"
      },
      {
        "name": "category",
        "value": "productos"
      },
      {
        "name": "dimension24",
        "value": "productos"
      },
      {
        "name": "dimension35",
        "value": ""
      },
      {
        "name": "dimension36",
        "value": ""
      },
      {
        "name": "dimension37",
        "value": this.timeSeries(product.detailModal.validity)
      },
      {
        "name": "dimension38",
        "value": aditional==true ? product.summary : product.summary.join(" - ")
      },
      {
        "name": "dimension39",
        "value": ""
      },
      {
        "name": "id",
        "value": product.id
      },
      {
        "name": "name",
        "value": product.name
      },
      {
        "name": "price",
        "value": product.price
      },
      {
        "name": "quantity",
        "value": 1
      },
      {
        "name": "variant",
        "value": this.timeSeries(product.detailModal.validity)
      }
    ];
    let basePrice = product.basePrice;
    if (product.discount !== 0) {
      let basePriceDiscount = product.basePrice - (product.basePrice * product.discount / 100);
      basePrice = basePriceDiscount;
    }
    let quantity = product.quantity
    if (tipoItem == 1) {
      quantity = 1
    }
    let productData = {
      "price": basePrice,
      "product_id": product.carritoId,
      "quantity": quantity,
      "productos_analytics": dataLayer,
      "external_product_id": product.external_product_id,
      "observations": {
        "proyectoId": "1",
        "item": product.id,
        "tipoItem": tipoItem
      },
      "marketo_lead": {
        "cCTD": this.userInformation.typeDocument,
        "cCID": this.userInformation.identification,
        "Email": this.userInformation.email,
        "MobilePhone": this.userInformation.phone,
        "FirstName": this.userInformation.name,
        "LastName": this.userInformation.lastname,
        "cCInmobiliaria": this.userInformation.typeUser === 2 ? 1 : 0,
        "cCConstructora": this.userInformation.typeUser === 4 ? 1 : 0,
        "cCAgente": this.userInformation.typeUser === 3 ? 1 : 0,
        "cCPPN": this.userInformation.typeUser === 9 ? 1 : 0,
        "cCOrigendelosDatos": environment.name,
        "cCPrueba": environment.production === false ? 1 : 0,
        "cCConsentimientoComercial": true,
        "cCConsentimiento": true,
        "cCRegistroSolicitudAvaluo": false
      },
      "marketo_custom_object": {
        "iDUsuario": this.userInformation.id,
        "Email": this.userInformation.email,
        "token": this.cookieCiencuadras.getCookie("tokenProduct"),
        "tipoDeUsuario": this.cookieCiencuadras.getCookie("typeUser"),
        "tipoDePlan": this.plansSelected.length > 0 ? this.plansSelected[0].name : "",
        "cuposPublicaciones": localStorage.getItem("quotasPublications"),
        "estadoPlan": localStorage.getItem("statusProduct"),
        "duracionPlan": this.plansSelected.length > 0 ? this.plansSelected[0].descriptionValuePlan : "",
        "fechaInicioPlan": localStorage.getItem("startDate"),
        "fechaFinPlan": localStorage.getItem("endDate"),
        "valorPlan": this.plansSelected.length > 0 ? this.plansSelected[0].price : 0,
        "nombreProducto": this.aditionalProducts.length > 0 ? product.name : product.name ? "" : "",
        "valorProducto": this.aditionalProducts.length > 0 ? product.price : product.price ? 0: 0,
        "cuposProducto": quantity,
        "fechaInicioProducto": localStorage.getItem("startDate"),
        "fechaFinProducto": localStorage.getItem("endDateProducts"),
        "estadoProducto": localStorage.getItem("statusProduct"),
        "fechaActualizacionRegistro": localStorage.getItem("updateDate")
      }
    }
    return productData;
  }

  async saveTransactionService() {
    const planes: Plan[] = this.plansSelected;
    const productos: ProductCar[] = this.aditionalProducts;
    let padreId: number = null!;
    let token = localStorage.getItem('tokenProduct');

    let transaccionCarritoDet: any = [];

    const userID = (this.userInformation.identification) ? this.userInformation.identification : this.userInformation.id.toString();
    if (planes.length > 0) {
      let plan = planes[0];
      padreId = plan.id;
      let basePrice = plan.basePrice;
      if (plan.discount !== 0) {
        let basePriceDiscount = plan.basePrice - (plan.basePrice * plan.discount / 100);
        basePrice = basePriceDiscount;
      }
      transaccionCarritoDet.push(
        {
          "cantidad": 1,
          "itemId": plan.id,
          "tipo": 1,
          "valorTotal": basePrice,
          "observations": {
            "proyectoId": "1",
            "item": plan.id,
            "tipoItem": 1,
          },
          "marketo_lead": {
            "cCTD": this.userInformation.typeDocument,
            "cCID": this.userInformation.identification,
            "Email": this.userInformation.email,
            "MobilePhone": this.userInformation.phone,
            "FirstName": this.userInformation.name,
            "LastName": this.userInformation.lastname,
            "cCInmobiliaria": this.userInformation.typeUser === 2 ? 1 : 0,
            "cCConstructora": this.userInformation.typeUser === 4 ? 1 : 0,
            "cCAgente": this.userInformation.typeUser === 3 ? 1 : 0,
            "cCPPN": this.userInformation.typeUser === 9 ? 1 : 0,
            "cCOrigendelosDatos": environment.name,
            "cCPrueba": environment.production === false ? 1 : 0,
            "cCConsentimientoComercial": true,
            "cCConsentimiento": true,
            "cCRegistroSolicitudAvaluo": false
          },
          "marketo_custom_object": {
            "iDUsuario": this.userInformation.id,
            "Email": this.userInformation.email,
            "token": this.cookieCiencuadras.getCookie("tokenProduct"),
            "tipoDeUsuario": this.cookieCiencuadras.getCookie("typeUser"),
            "tipoDePlan": plan.name,
            "cuposPublicaciones": localStorage.getItem("quotasPublications"),
            "estadoPlan": localStorage.getItem("statusProduct"),
            "duracionPlan": this.plansSelected.length > 0 ? this.plansSelected[0].descriptionValuePlan : "",
            "fechaInicioPlan": localStorage.getItem("startDate"),
            "fechaFinPlan": localStorage.getItem("endDate"),
            "valorPlan": plan.price,
            "nombreProducto": "",
            "valorProducto": 0,
            "cuposProducto": 0,
            "fechaInicioProducto": "",
            "fechaFinProducto": "",
            "estadoProducto": "",
            "fechaActualizacionRegistro": localStorage.getItem("updateDate")
          }
        }
      );
      let includedProducts = plan.includedProducts;
      includedProducts.forEach(producto => {
        transaccionCarritoDet.push(
          {
            "padreId": padreId,
            "cantidad": producto.cantidadXPlan,
            "itemId": producto.id,
            "tipo": 2,
            "valorTotal": 0,
            "observations": {
              "proyectoId": "1",
              "item": producto.id,
              "tipoItem": 2
            },
            "marketo_lead": {
              "cCTD": this.userInformation.typeDocument,
              "cCID": this.userInformation.identification,
              "Email": this.userInformation.email,
              "MobilePhone": this.userInformation.phone,
              "FirstName": this.userInformation.name,
              "LastName": this.userInformation.lastname,
              "cCInmobiliaria": this.userInformation.typeUser === 2 ? 1 : 0,
              "cCConstructora": this.userInformation.typeUser === 4 ? 1 : 0,
              "cCAgente": this.userInformation.typeUser === 3 ? 1 : 0,
              "cCPPN": this.userInformation.typeUser === 9 ? 1 : 0,
              "cCOrigendelosDatos": environment.name,
              "cCPrueba": environment.production === false ? 1 : 0,
              "cCConsentimientoComercial": true,
              "cCConsentimiento": true,
              "cCRegistroSolicitudAvaluo": false
            },
            "marketo_custom_object": {
              "iDUsuario": this.userInformation.id,
              "Email": this.userInformation.email,
              "token": this.cookieCiencuadras.getCookie("tokenProduct"),
              "tipoDeUsuario": this.cookieCiencuadras.getCookie("typeUser"),
              "tipoDePlan": "",
              "cuposPublicaciones": 0,
              "estadoPlan": "",
              "duracionPlan": "",
              "fechaInicioPlan": "",
              "fechaFinPlan": "",
              "valorPlan": 0,
              "nombreProducto": producto.nombre,
              "valorProducto": producto.precio,
              "cuposProducto": producto.cantidadXPlan,
              "fechaInicioProducto": localStorage.getItem("startDate"),
              "fechaFinProducto": localStorage.getItem("endDateProducts"),
              "estadoProducto": localStorage.getItem("statusProduct"),
              "fechaActualizacionRegistro": localStorage.getItem("updateDate")
            }
          }
        );

      });
    }
    if (productos.length > 0) {
      productos.forEach(producto => {
        let basePrice = producto.basePrice;
        if (producto.discount !== 0) {
          let basePriceDiscount = producto.basePrice - (producto.basePrice * producto.discount / 100);
          basePrice = basePriceDiscount;
        }
        transaccionCarritoDet.push(
          {
            "cantidad": producto.quantity,
            "itemId": producto.id,
            "tipo": 2,
            "valorTotal": basePrice,
            "observations": {
              "proyectoId": "1",
              "item": producto.id,
              "tipoItem": 2
            },
            "marketo_lead": {
              "cCTD": this.userInformation.typeDocument,
              "cCID": this.userInformation.identification,
              "Email": this.userInformation.email,
              "MobilePhone": this.userInformation.phone,
              "FirstName": this.userInformation.name,
              "LastName": this.userInformation.lastname,
              "cCInmobiliaria": this.userInformation.typeUser === 2 ? 1 : 0,
              "cCConstructora": this.userInformation.typeUser === 4 ? 1 : 0,
              "cCAgente": this.userInformation.typeUser === 3 ? 1 : 0,
              "cCPPN": this.userInformation.typeUser === 9 ? 1 : 0,
              "cCOrigendelosDatos": environment.name,
              "cCPrueba": environment.production === false ? 1 : 0,
              "cCConsentimientoComercial": true,
              "cCConsentimiento": true,
              "cCRegistroSolicitudAvaluo": false
            },
            "marketo_custom_object": {
              "iDUsuario": this.userInformation.id,
              "Email": this.userInformation.email,
              "token": this.cookieCiencuadras.getCookie("tokenProduct"),
              "tipoDeUsuario": this.cookieCiencuadras.getCookie("typeUser"),
              "tipoDePlan": "",
              "cuposPublicaciones": 0,
              "estadoPlan": "",
              "duracionPlan": "",
              "fechaInicioPlan": "",
              "fechaFinPlan": "",
              "valorPlan": 0,
              "nombreProducto": producto.name,
              "valorProducto": basePrice,
              "cuposProducto": producto.quantity,
              "fechaInicioProducto": localStorage.getItem("startDate"),
              "fechaFinProducto": localStorage.getItem("endDateProducts"),
              "estadoProducto": localStorage.getItem("statusProduct"),
              "fechaActualizacionRegistro": localStorage.getItem("updateDate")
            }
          }
        );
      });
    }
    this.productsService.savePurchaseIntent(
      this.userInformation.name, // last name
      this.userInformation.email, // user email
      this.userInformation.name, //name
      userID, // user cc o id
      1,
      token,
      transaccionCarritoDet,
      this.userInformation.id, // user id
      this.summaryP
    ).pipe().subscribe(async res => {
      console.log('------------------ savePurchaseIntent:', res);
      // 
      if (res.status === 'ok') {
        this.dialog.closeAll();
      } else {
        this.isSaveTransactionFail = true;
      }
    }, async (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log('An error occurred:', err.error.message);
      } else {
        this.isSaveTransactionFail = true;
        console.log('Backend returned status code: ', err.status);
        console.log('Response body:', err.error);
      }
    });

  }

  async getUserInformation(id: string): Promise<boolean> {

    return new Promise((resolve) => {
      this.productsService.getUserInformation(
        id
      ).pipe().subscribe(res => {
        if (res.status) {
          let cripto = new Encrypt();
          this.userInformation = res.data;
          this.cookieCiencuadras.setCookie('userInfo', cripto.encryptData(this.userInformation));
          resolve(true);
        }
        resolve(false);
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('An error occurred:', err.error.message);
        } else {
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
        }
        resolve(false);
      });
    });
  }

  private timeSeries(value) {
    switch (value) {
      case 1:
        return 'mensual'
      case 6:
        return 'semestral'
      case 12:
        return 'anual'   
      default:
        return 'no aplica';
    }
  }
}

